(function () {
  'use strict';

  // ---------------------------------------------------------------------
  // Storefront API config. The access token below is a PUBLIC, read-only
  // Storefront API token (Shopify explicitly designs these to be safe to
  // ship in client-side code — it can only read published storefront data,
  // nothing sensitive). Requires the "product_gender_context" metafield to
  // have Storefront API visibility enabled if any code later reads it here
  // (not needed by this file, only by we-think-youll-love.js).
  // ---------------------------------------------------------------------
  var SHOPIFY_STOREFRONT = {
    domain: 'caseteroid-world.myshopify.com',
    apiVersion: '2025-10',
    token: '19036fccaffbf1d598a2c10518f434c2'
  };

  function storefrontQuery(query, variables) {
    return fetch('https://' + SHOPIFY_STOREFRONT.domain + '/api/' + SHOPIFY_STOREFRONT.apiVersion + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': SHOPIFY_STOREFRONT.token
      },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) { return r.json(); });
  }

  // Returns [{handle, title, tags}] for every product carrying the given
  // tag value (e.g. "design_uid:CT076"). Tag values with a colon MUST be
  // single-quoted in the Storefront search query syntax, otherwise the
  // colon is parsed as a field filter and the query silently matches nothing.
  function fetchProductsByTag(tagValue, first) {
    var gql =
      'query($q: String!, $first: Int!) {' +
      '  products(first: $first, query: $q) {' +
      '    edges { node { handle title tags } }' +
      '  }' +
      '}';
    var q = "tag:'" + tagValue + "'";
    return storefrontQuery(gql, { q: q, first: first || 100 }).then(function (res) {
      if (res.errors) {
        console.error('Storefront API error:', res.errors);
        return [];
      }
      return res.data.products.edges.map(function (e) { return e.node; });
    });
  }

  function fetchJSON(url) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('Failed to fetch ' + url);
      return r.json();
    });
  }

  function fetchProduct(handle) {
    return fetchJSON('/products/' + handle + '.js');
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('Add to cart failed');
      return r.json();
    });
  }

  function formatMoney(cents, currencyCode) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode || 'USD'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function truncate(str, max) {
    if (!str) return str;
    return str.length > max ? str.slice(0, max - 1) + '…' : str;
  }

  // Ported from generate_cart_configs.py's categorize(), same rules used to
  // build design-groups.json. Now runs client-side against products the
  // Storefront API returns, instead of a pre-built JSON key.
  function categorize(device) {
    var d = (device || '').toLowerCase();
    if (d.indexOf('iphone') === 0) return 'Phone Case';
    if (d.indexOf('samsung galaxy buds') !== -1) return 'Buds Case';
    if (d.indexOf('samsung galaxy') === 0) return 'Phone Case';
    if (d.indexOf('airpods') === 0) return 'AirPods Case';
    if (d.indexOf('kindle') === 0) return 'Kindle Case';
    if (d.indexOf('ipad') === 0) return 'iPad Case';
    if (d.indexOf('macbook') === 0) return 'MacBook Case';
    if (d === 'laptop sleeve') return 'Laptop Sleeve';
    if (d.indexOf('magnetic wallet') !== -1) return 'Magnetic Wallet & Stand';
    if (d.indexOf('magnetic ring holder') !== -1) return 'Ring Holder';
    if (d.indexOf('chargepod') !== -1 || d.indexOf('power bank') !== -1) return 'Power Bank';
    return 'Other';
  }

  // Controls the left-to-right order of recommendation categories.
  // Screen Protector is always first (handled separately below) and isn't listed here.
 var CATEGORY_ORDER = [
  'iPhone Case',
  'Samsung Case',
  'Ring Holder',
  'Magnetic Wallet & Stand',
  'Power Bank',
  'Crossbody Strap',
  'Wrist Strap',
  'AirPods Case',
  'Kindle Case',
  'iPad Case',
  'MacBook Case',
  'Laptop Sleeve'
];

// Categories fully discontinued sitewide, regardless of phone brand/type.
var GLOBALLY_EXCLUDED_CATEGORIES = ['Buds Case'];

  // Categories where each design only has ONE product, and that product's
  // own native Shopify variants (not separate design-groups items) are the
  // real options to show in the dropdown.
  var NATIVE_VARIANT_CATEGORIES = ['Laptop Sleeve', 'Magnetic Wallet & Stand', 'Ring Holder', 'Power Bank'];

  // Explicit newest-to-oldest device order (matches your site navigation),
  // used to sort dropdown options instead of relying on alphabetical order.
  var DEVICE_ORDER = [
    'iPhone 18 Pro Max', 'iPhone 18 Pro',
    'iPhone 17 Pro Max', 'iPhone 17 Pro', 'iPhone Air', 'iPhone 17',
    'iPhone 16 Pro Max', 'iPhone 16 Pro', 'iPhone 16 Plus', 'iPhone 16',
    'iPhone 15 Pro Max', 'iPhone 15 Pro', 'iPhone 15 Plus', 'iPhone 15',
    'iPhone 14 Pro Max', 'iPhone 14 Pro', 'iPhone 14 Plus', 'iPhone 14',
    'iPhone 13 Pro Max', 'iPhone 13 Pro', 'iPhone 13', 'iPhone 13 Mini',

    'Samsung Galaxy S26 Ultra', 'Samsung Galaxy S26 Plus', 'Samsung Galaxy S26',
    'Samsung Galaxy S25 Ultra', 'Samsung Galaxy S25 Plus', 'Samsung Galaxy S25',
    'Samsung Galaxy S24 Ultra', 'Samsung Galaxy S24 Plus', 'Samsung Galaxy S24',
    'Samsung Galaxy S23 Ultra', 'Samsung Galaxy S23 Plus', 'Samsung Galaxy S23',

    'Samsung Galaxy Z Flip 7', 'Samsung Galaxy Z Flip 6',
    'Samsung Galaxy Z Flip 5', 'Samsung Galaxy Z Flip 4',

    'AirPods Pro 3', 'AirPods Pro 2', 'AirPods Pro',
    'AirPods 5', 'AirPods 4', 'AirPods 3', 'AirPods Max',

    'Samsung Galaxy Buds Pro 2', 'Samsung Galaxy Buds 2', 'Samsung Galaxy Buds Pro',
    'Samsung Galaxy Buds Live', 'Samsung Galaxy Buds Plus', 'Samsung Galaxy Buds FE',

    // Kindle models, in the order they appear in the dropdown
    'Kindle Paperwhite (12th Gen)', 'Kindle Paperwhite Signature Edition (12th Gen)',
    'Kindle Paperwhite (11th Gen)', 'Kindle Colorsoft (1st Gen)',
    'Kindle Colorsoft Signature Edition (1st Gen)',

    'iPad Pro 13 (8th/7th Gen)', 'iPad Pro 12.9 (6th/5th Gen)', 'iPad Pro 12.9 (4th/3rd Gen)',
    'iPad Pro 11 (8th/7th Gen)', 'iPad Pro 11 (4th/3rd Gen)', 'iPad Pro 11 (2nd/1st Gen)',
    'iPad Air 13 (8th/7th/6th Gen)', 'iPad Air 11 (7th/6th Gen)',
    'iPad 10.9 (10th Gen)', 'iPad Air 10.9 (5th/4th Gen)',

    'MacBook Neo', 'MacBook Air', 'MacBook Pro'
  ];

  function deviceOrderIndex(deviceLabel) {
    // old Kindle names with the "6" / "5" (Paperwhite 6, Paperwhite 5) still sort correctly
    var normalized = (deviceLabel || '').replace(/\s*case\s*$/i, '').replace(/(Kindle Paperwhite) [56]\b/i, '$1').trim();
    var index = DEVICE_ORDER.indexOf(normalized);
    return index === -1 ? DEVICE_ORDER.length : index;
  }

  function sortItemsByDeviceOrder(items) {
    return items.slice().sort(function (a, b) {
      var diff = deviceOrderIndex(a.device) - deviceOrderIndex(b.device);
      if (diff !== 0) return diff;
      return a.device.localeCompare(b.device);
    });
  }

  // Internal category keys don't always match how they should read on-screen.
  var CATEGORY_DISPLAY_NAMES = {
    'Ring Holder': 'Magnetic Ring Holder'
  };

  function displayCategoryName(categoryName) {
    return CATEGORY_DISPLAY_NAMES[categoryName] || categoryName;
  }

  var SCREEN_PROTECTORS = {
    iphone: 'iphone-full-cover-premium-screen-protector',
    samsung: 'samsung-full-cover-screen-protector'
  };

  var STRAP_CONFIG = {
    'Wrist Strap': {
      Black: 'black-wrist-phone-case-strap',
      Beige: 'beige-wrist-phone-case-strap'
    },
    'Crossbody Strap': {
      Black: 'black-crossbody-phone-case-strap',
      Beige: 'beige-crossbody-phone-case-strap'
    }
  };

  function detectBrand(deviceString) {
    var d = (deviceString || '').toLowerCase();
    if (d.indexOf('iphone') === 0) return 'iphone';
    if (d.indexOf('samsung galaxy') === 0 && d.indexOf('buds') === -1 && d.indexOf('z flip') === -1) return 'samsung';
    return null; // includes Z Flip: no screen protector product exists for it
  }

  function isZFlip(deviceString) {
    return (deviceString || '').toLowerCase().indexOf('z flip') !== -1;
  }

  // Z Flip 8 is the first Z Flip generation with a magnetic/MagSafe-style
  // case option, so unlike earlier Z Flip models it should NOT get the
  // magnetic-accessory exclusions below. Add any future magnetic-capable
  // Z Flip generations to this list.
  var ZFLIP_MAGNETIC_CAPABLE = ['z flip 8'];

  function isZFlipMagneticCapable(deviceString) {
    var d = (deviceString || '').toLowerCase();
    return ZFLIP_MAGNETIC_CAPABLE.some(function (gen) { return d.indexOf(gen) !== -1; });
  }

  // Which categories to exclude per phone type, since not every accessory
  // makes sense for every brand/device:
  // - iPhone owners shouldn't be shown Samsung's Buds Case
  // - Samsung owners shouldn't be shown AirPods Case
  // - Z Flip is a folding phone: no magnetic/MagSafe accessories (they interfere
  //   with the fold) and AirPods still doesn't apply since it's Samsung
  // - Z Flip 8 (and any future magnetic-capable Z Flip) DOES support magnetic
  //   accessories, so only AirPods Case is excluded for it
  var CATEGORY_EXCLUSIONS = {
    iphone: ['Buds Case'],
    samsung: ['AirPods Case'],
    samsung_zflip: ['AirPods Case', 'Magnetic Wallet & Stand', 'Ring Holder', 'Power Bank'],
    samsung_zflip_magnetic: ['AirPods Case']
  };

  function getPhoneTypeKey(deviceString) {
    if (isZFlip(deviceString)) {
      return isZFlipMagneticCapable(deviceString) ? 'samsung_zflip_magnetic' : 'samsung_zflip';
    }
    return detectBrand(deviceString); // 'iphone', 'samsung', or null
  }

  // Guesses which screen protector variant matches the current product's
  // exact device (e.g. "iPhone 17 Pro Max Case" -> tries to match "17 Pro Max").
  function cleanDeviceLabel(deviceString) {
    return (deviceString || '')
      .replace(/case\s*$/i, '')
      .replace(/^iphone\s*/i, '')
      .replace(/^samsung galaxy\s*/i, '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function guessMatchingVariant(product, deviceString) {
    var cleaned = cleanDeviceLabel(deviceString);
    if (!cleaned) return product.variants[0];

    var candidates = product.variants.map(function (v) {
      var title = cleanDeviceLabel(v.public_title || v.title || '');
      return { variant: v, title: title };
    });

    // 1. Exact match after normalizing both sides.
    var exact = candidates.find(function (c) { return c.title === cleaned; });
    if (exact) return exact.variant;

    // 2. Best partial match: prefer the LONGEST matching title, to avoid
    //    "16 pro" incorrectly matching "16 pro max" instead of "16 pro".
    var partials = candidates.filter(function (c) {
      return c.title.indexOf(cleaned) !== -1 || cleaned.indexOf(c.title) !== -1;
    });
    if (partials.length > 0) {
      partials.sort(function (a, b) { return b.title.length - a.title.length; });
      // Prefer the shortest candidate that's still an exact-length match to cleaned,
      // falling back to closest length match overall.
      var closest = candidates
        .filter(function (c) { return c.title.indexOf(cleaned) !== -1; })
        .sort(function (a, b) {
          return Math.abs(a.title.length - cleaned.length) - Math.abs(b.title.length - cleaned.length);
        })[0];
      return (closest || partials[0]).variant;
    }

    return product.variants[0];
  }

  // Card image: clicking it opens that product's page (the product currently selected in the card).
  function setMedia(mediaEl, product, src) {
    var img = '<img src="' + src + '" alt="' + product.title + '" loading="lazy" />';
    mediaEl.innerHTML = product.handle
      ? '<a href="/products/' + product.handle + '" aria-label="' + String(product.title).replace(/"/g, '&quot;') + '" style="display:block;width:100%;height:100%">' + img + '</a>'
      : img;
  }

  function buildCardShell() {
    var wrapper = document.createElement('div');
    wrapper.className = 'rfy-card';
    wrapper.innerHTML =
      '<div class="rfy-card__media" data-media></div>' +
      '<div class="rfy-card__body">' +
        '<p class="rfy-card__title" data-title></p>' +
        '<p class="rfy-card__subtitle" data-subtitle></p>' +
        '<p class="rfy-card__price" data-price></p>' +
        '<select class="rfy-card__select" data-select></select>' +
        '<button type="button" class="rfy-card__add" data-add-btn disabled>ADD TO CART</button>' +
      '</div>';
    return wrapper;
  }

  function wireAddButton(addBtn, getVariantId) {
    addBtn.addEventListener('click', function () {
      var variantId = getVariantId();
      if (!variantId) return;
      addBtn.disabled = true;
      addBtn.textContent = 'ADDING...';
      addToCart(variantId, 1).then(function () {
        addBtn.textContent = 'ADDED';
        addBtn.classList.add('is-added');
        setTimeout(function () {
          addBtn.textContent = 'ADD TO CART';
          addBtn.classList.remove('is-added');
          addBtn.disabled = false;
        }, 1500);
      }).catch(function () {
        addBtn.textContent = 'ADD TO CART';
        addBtn.disabled = false;
      });
    });
  }

  // Specialized card for iPhone Case / Samsung Case recommendations: unlike
  // the generic design card, this always auto-selects the MagSafe (iPhone) or
  // Magnetic (Samsung) variant specifically, with a badge showing which case
  // type it is, rather than offering a separate type dropdown.
  function buildPhoneCaseCard(designName, itemsRaw, currencyCode, variantKeyword, badgeLabel) {
    var items = sortItemsByDeviceOrder(itemsRaw);
    var wrapper = buildCardShell();
    wrapper.querySelector('[data-title]').textContent = designName;

    var deviceSelect = wrapper.querySelector('[data-select]');
    deviceSelect.innerHTML = items.map(function (item) {
      return '<option value="' + item.handle + '">' + truncate(item.device, 28) + '</option>';
    }).join('');

    var mediaEl = wrapper.querySelector('[data-media]');
    var subtitleEl = wrapper.querySelector('[data-subtitle]');
    var priceEl = wrapper.querySelector('[data-price]');
    var addBtn = wrapper.querySelector('[data-add-btn]');

    var badgeEl = document.createElement('p');
    badgeEl.className = 'rfy-card__badge';
    badgeEl.textContent = badgeLabel;
    subtitleEl.parentNode.insertBefore(badgeEl, subtitleEl.nextSibling);

    var productCache = {};
    var selectedVariantId = null;

    function selectHandle(handle, deviceLabel) {
      subtitleEl.textContent = deviceLabel;
      subtitleEl.title = deviceLabel;
      if (productCache[handle]) {
        applyProduct(productCache[handle]);
        return;
      }
      addBtn.disabled = true;
      fetchProduct(handle).then(function (product) {
        productCache[handle] = product;
        applyProduct(product);
      });
    }

    function applyProduct(product) {
      var available = product.variants.filter(function (v) { return v.available; });
      var pool = available.length > 0 ? available : product.variants;

      var match = pool.find(function (v) {
        var t = (v.public_title || v.title || '').toLowerCase();
        return t.indexOf(variantKeyword) !== -1;
      });
      var chosen = match || pool[0];

      var img = chosen.featured_image ? chosen.featured_image.src : product.featured_image;
      setMedia(mediaEl, product, img);
      priceEl.textContent = formatMoney(chosen.price, currencyCode);
      selectedVariantId = chosen.id;
      addBtn.disabled = !selectedVariantId;
    }

    deviceSelect.addEventListener('change', function () {
      var item = items.find(function (i) { return i.handle === deviceSelect.value; });
      selectHandle(deviceSelect.value, item ? item.device : '');
    });

    wireAddButton(addBtn, function () { return selectedVariantId; });
    selectHandle(items[0].handle, items[0].device);
    return wrapper;
  }
  // second dropdown for the selected product's own variants (e.g. Tough vs
  // Tough MagSafe for iPhone, Tough vs Tough Magnetic for Samsung), since
  // each device-specific product can itself have real case-type variants.
  function buildDesignCard(designName, itemsRaw, currencyCode) {
    var items = sortItemsByDeviceOrder(itemsRaw);
    var wrapper = buildCardShell();
    wrapper.querySelector('[data-title]').textContent = designName;

    // Insert a second select for case type, right after the device select.
    var deviceSelect = wrapper.querySelector('[data-select]');
    var typeSelect = document.createElement('select');
    typeSelect.className = 'rfy-card__select';
    typeSelect.setAttribute('data-type-select', '');
    typeSelect.style.display = 'none';
    deviceSelect.parentNode.insertBefore(typeSelect, deviceSelect.nextSibling);

    var optionsHtml = items.map(function (item) {
      // Kindle model names are long ("... Signature Edition (12th Gen)"): drop " Case" and don't cut them short
      var isKindle = /^kindle/i.test(item.device);
      var label = isKindle ? item.device.replace(/\s*case\s*$/i, '') : item.device;
      return '<option value="' + item.handle + '">' + truncate(label, isKindle ? 60 : 28) + '</option>';
    }).join('');
    deviceSelect.innerHTML = optionsHtml;

    var mediaEl = wrapper.querySelector('[data-media]');
    var subtitleEl = wrapper.querySelector('[data-subtitle]');
    var priceEl = wrapper.querySelector('[data-price]');
    var addBtn = wrapper.querySelector('[data-add-btn]');

    var productCache = {};
    var selectedVariantId = null;

    function selectHandle(handle, deviceLabel) {
      subtitleEl.textContent = deviceLabel;
      subtitleEl.title = deviceLabel;
      if (productCache[handle]) {
        applyProduct(productCache[handle]);
        return;
      }
      addBtn.disabled = true;
      fetchProduct(handle).then(function (product) {
        productCache[handle] = product;
        applyProduct(product);
      });
    }

    function applyProduct(product) {
      var availableVariants = product.variants.filter(function (v) { return v.available; });
      var variantsToShow = availableVariants.length > 0 ? availableVariants : product.variants;

      var hasRealOptions = variantsToShow.length > 1 &&
        variantsToShow.some(function (v) {
          var t = (v.public_title || v.title || '').toLowerCase();
          return t !== 'default title';
        });

      if (hasRealOptions) {
        typeSelect.style.display = '';
        typeSelect.innerHTML = variantsToShow.map(function (v) {
          return '<option value="' + v.id + '">' + truncate(v.public_title || v.title, 28) + '</option>';
        }).join('');
      } else {
        typeSelect.style.display = 'none';
      }

      function applyVariant(variant) {
        var img = variant.featured_image ? variant.featured_image.src : product.featured_image;
        setMedia(mediaEl, product, img);
        priceEl.textContent = formatMoney(variant.price, currencyCode);
        selectedVariantId = variant.id;
        addBtn.disabled = !selectedVariantId;
      }

      applyVariant(variantsToShow[0]);

      typeSelect.onchange = function () {
        var v = variantsToShow.find(function (vv) { return String(vv.id) === typeSelect.value; });
        if (v) applyVariant(v);
      };
    }

    deviceSelect.addEventListener('change', function () {
      var item = items.find(function (i) { return i.handle === deviceSelect.value; });
      selectHandle(deviceSelect.value, item ? item.device : '');
    });

    wireAddButton(addBtn, function () { return selectedVariantId; });
    selectHandle(items[0].handle, items[0].device);
    return wrapper;
  }

  // Card for categories where it's ONE product with its own real Shopify
  // variants (Laptop Sleeve, Power Bank, Magnetic Wallet & Stand, Ring Holder).
  function buildNativeVariantCard(designName, handle, currencyCode, categoryName) {
    var wrapper = buildCardShell();
    wrapper.querySelector('[data-title]').textContent = designName;

    var mediaEl = wrapper.querySelector('[data-media]');
    var subtitleEl = wrapper.querySelector('[data-subtitle]');
    var priceEl = wrapper.querySelector('[data-price]');
    var select = wrapper.querySelector('[data-select]');
    var addBtn = wrapper.querySelector('[data-add-btn]');

    fetchProduct(handle).then(function (product) {
      var availableVariants = product.variants.filter(function (v) { return v.available; });
      var variantsToShow = availableVariants.length > 0 ? availableVariants : product.variants;

      var hasRealOptions = variantsToShow.length > 1 &&
        variantsToShow.some(function (v) {
          var t = (v.public_title || v.title || '').toLowerCase();
          return t !== 'default title';
        });

      if (!hasRealOptions) {
        select.style.display = 'none';
      } else {
        select.innerHTML = variantsToShow.map(function (v) {
          return '<option value="' + v.id + '">' + truncate(v.public_title || v.title, 28) + '</option>';
        }).join('');
      }

      function applyVariant(variant) {
        var img = variant.featured_image ? variant.featured_image.src : product.featured_image;
        setMedia(mediaEl, product, img);
        priceEl.textContent = formatMoney(variant.price, currencyCode);

        if (hasRealOptions) {
          subtitleEl.textContent = variant.public_title || variant.title;
          subtitleEl.title = variant.public_title || variant.title;
        } else {
          subtitleEl.textContent = displayCategoryName(categoryName);
          subtitleEl.title = displayCategoryName(categoryName);
        }

        addBtn.disabled = !variant.id;
      }

      var currentVariantId = variantsToShow[0].id;
      applyVariant(variantsToShow[0]);

      if (hasRealOptions) {
        select.addEventListener('change', function () {
          var v = variantsToShow.find(function (vv) { return String(vv.id) === select.value; });
          if (v) {
            currentVariantId = v.id;
            applyVariant(v);
          }
        });
      }

      wireAddButton(addBtn, function () { return currentVariantId; });
    });

    return wrapper;
  }

  // First card: brand-matched screen protector, pre-selected to the exact
  // device model of the product being viewed.
  function buildScreenProtectorCard(brand, currentDevice, currencyCode) {
    var wrapper = buildCardShell();
    wrapper.querySelector('[data-title]').textContent = 'Screen Protector';

    var mediaEl = wrapper.querySelector('[data-media]');
    var subtitleEl = wrapper.querySelector('[data-subtitle]');
    var priceEl = wrapper.querySelector('[data-price]');
    var select = wrapper.querySelector('[data-select]');
    var addBtn = wrapper.querySelector('[data-add-btn]');

    var handle = SCREEN_PROTECTORS[brand];

    fetchProduct(handle).then(function (product) {
      var availableVariants = product.variants.filter(function (v) { return v.available; });
      var variantsToShow = availableVariants.length > 0 ? availableVariants : product.variants;

      select.innerHTML = variantsToShow.map(function (v) {
        return '<option value="' + v.id + '">' + truncate(v.public_title || v.title, 28) + '</option>';
      }).join('');

      var bestMatch = guessMatchingVariant({ variants: variantsToShow }, currentDevice);

      function applyVariant(variant) {
        var img = variant.featured_image ? variant.featured_image.src : product.featured_image;
        setMedia(mediaEl, product, img);
        priceEl.textContent = formatMoney(variant.price, currencyCode);
        subtitleEl.textContent = variant.public_title || variant.title;
        subtitleEl.title = variant.public_title || variant.title;
        addBtn.disabled = !variant.id;
      }

      var currentVariantId = bestMatch.id;
      select.value = bestMatch.id;
      applyVariant(bestMatch);

      select.addEventListener('change', function () {
        var v = variantsToShow.find(function (vv) { return String(vv.id) === select.value; });
        if (v) {
          currentVariantId = v.id;
          applyVariant(v);
        }
      });

      wireAddButton(addBtn, function () { return currentVariantId; });
    });

    return wrapper;
  }

  function buildStrapCard(title, colorHandles, currencyCode) {
    var wrapper = buildCardShell();
    wrapper.querySelector('[data-title]').textContent = title;

    var mediaEl = wrapper.querySelector('[data-media]');
    var subtitleEl = wrapper.querySelector('[data-subtitle]');
    var priceEl = wrapper.querySelector('[data-price]');
    var select = wrapper.querySelector('[data-select]');
    var addBtn = wrapper.querySelector('[data-add-btn]');

    select.innerHTML = Object.keys(colorHandles).map(function (colorName) {
      return '<option value="' + colorName + '">' + colorName + '</option>';
    }).join('');

    var productCache = {};
    var selectedVariantId = null;

    function selectColor(colorName) {
      subtitleEl.textContent = colorName;
      var handle = colorHandles[colorName];
      if (productCache[handle]) {
        applyProduct(productCache[handle]);
        return;
      }
      addBtn.disabled = true;
      fetchProduct(handle).then(function (product) {
        productCache[handle] = product;
        applyProduct(product);
      });
    }

    function applyProduct(product) {
      setMedia(mediaEl, product, (product.featured_image || ''));
      priceEl.textContent = formatMoney(product.price, currencyCode);
      selectedVariantId = product.variants[0] ? product.variants[0].id : null;
      addBtn.disabled = !selectedVariantId;
    }

    select.addEventListener('change', function () {
      selectColor(select.value);
    });

    wireAddButton(addBtn, function () { return selectedVariantId; });
    selectColor(Object.keys(colorHandles)[0]);
    return wrapper;
  }

  function init(container) {
    if (container.dataset.initialized) return;
    container.dataset.initialized = 'true';

    var currentHandle = container.dataset.currentHandle;
    var currentDevice = container.dataset.currentDevice || '';
    var designUid = container.dataset.designUid;
    var showStraps = container.dataset.showStraps === 'true';
    var grid = container.querySelector('[data-grid]');

    // No design_uid tag yet (product not tagged, or tagging still in
    // progress) - hide the widget rather than showing nothing useful.
    if (!designUid) {
      container.style.display = 'none';
      return;
    }

    Promise.all([
      fetchProductsByTag('design_uid:' + designUid, 100),
      fetchJSON('/cart.js')
    ]).then(function (results) {
      var relatedProducts = results[0];
      var cartCurrency = results[1].currency;
      var currencyCode = (typeof cartCurrency === 'string')
        ? cartCurrency
        : ((cartCurrency && cartCurrency.active) || 'USD');

      // Rebuild the "categories" grouping (same shape design-groups.json
      // used to provide for this one design) from the live product list.
      var categories = {};
      relatedProducts.forEach(function (p) {
        if (p.handle === currentHandle) return;
        var parts = p.title.split(' - ');
        if (parts.length < 2) return;
        var device = parts[parts.length - 1].trim();
        var cat = categorize(device);
        categories[cat] = categories[cat] || [];
        categories[cat].push({ handle: p.handle, title: p.title, device: device });
      });

      var currentCategory = categorize(currentDevice);
      var currentDesign = relatedProducts.length > 0 ? relatedProducts[0].title.split(' - ')[0].trim() : '';

      var cards = [];

      // Determine which categories should be excluded for this specific
      // phone brand/model (e.g. no AirPods for Samsung, no magnetic
      // accessories for Z Flip).
      var phoneTypeKey = getPhoneTypeKey(currentDevice);
      var excludedCategories = (phoneTypeKey && CATEGORY_EXCLUSIONS[phoneTypeKey]) || [];

      // 1. Screen protector always first, if this device has a matching brand.
      var brand = detectBrand(currentDevice);
      if (brand) {
        cards.push({ sortKey: -1, el: buildScreenProtectorCard(brand, currentDevice, currencyCode) });
      }

      // 2. Design-matched categories, in the controlled order.
      Object.keys(categories).forEach(function (categoryName) {
        if (categoryName === currentCategory) return;
        if (GLOBALLY_EXCLUDED_CATEGORIES.indexOf(categoryName) !== -1) return;
        if (excludedCategories.indexOf(categoryName) !== -1) return;
        var items = categories[categoryName];
        if (!items || items.length === 0) return;

        // "Phone Case" combines iPhone and Samsung models together in the
        // data; split them into two separate cards so each brand shows on
        // its own (useful when viewing an accessory product).
        if (categoryName === 'Phone Case') {
          var iphoneItems = items.filter(function (i) { return (i.device || '').toLowerCase().indexOf('iphone') === 0; });
          var samsungItems = items.filter(function (i) { return (i.device || '').toLowerCase().indexOf('samsung galaxy') === 0; });

          if (iphoneItems.length > 0) {
            var iphoneSortIndex = CATEGORY_ORDER.indexOf('iPhone Case');
            if (iphoneSortIndex === -1) iphoneSortIndex = CATEGORY_ORDER.length;
            cards.push({ sortKey: iphoneSortIndex, el: buildPhoneCaseCard(currentDesign, iphoneItems, currencyCode, 'magsafe', 'MagSafe') });
          }
          if (samsungItems.length > 0) {
            var samsungSortIndex = CATEGORY_ORDER.indexOf('Samsung Case');
            if (samsungSortIndex === -1) samsungSortIndex = CATEGORY_ORDER.length;
            cards.push({ sortKey: samsungSortIndex, el: buildPhoneCaseCard(currentDesign, samsungItems, currencyCode, 'magnetic', 'Magnetic') });
          }
          return;
        }

        var sortIndex = CATEGORY_ORDER.indexOf(categoryName);
        if (sortIndex === -1) sortIndex = CATEGORY_ORDER.length;

        var cardEl;
        if (NATIVE_VARIANT_CATEGORIES.indexOf(categoryName) !== -1) {
          cardEl = buildNativeVariantCard(currentDesign, items[0].handle, currencyCode, categoryName);
        } else {
          cardEl = buildDesignCard(currentDesign, items, currencyCode);
        }
        cards.push({ sortKey: sortIndex, el: cardEl });
      });

      // 3. Straps last.
      if (showStraps) {
        ['Wrist Strap', 'Crossbody Strap'].forEach(function (strapName) {
          var sortIndex = CATEGORY_ORDER.indexOf(strapName);
          if (sortIndex === -1) sortIndex = CATEGORY_ORDER.length;
          cards.push({ sortKey: sortIndex, el: buildStrapCard(strapName, STRAP_CONFIG[strapName], currencyCode) });
        });
      }

      if (cards.length === 0) {
        container.style.display = 'none';
        return;
      }

      cards.sort(function (a, b) { return a.sortKey - b.sortKey; });
      cards.forEach(function (c) { grid.appendChild(c.el); });

      setupScrollThumb(container, grid);
    }).catch(function (err) {
      console.error('Recommended for you error:', err);
    });
  }

  function setupScrollThumb(container, grid) {
    var thumb = container.querySelector('[data-scroll-thumb]');
    if (!thumb) return;

    function update() {
      var scrollable = grid.scrollWidth - grid.clientWidth;
      if (scrollable <= 0) {
        thumb.parentElement.style.display = 'none';
        return;
      }
      thumb.parentElement.style.display = 'block';
      var thumbWidthPct = Math.max((grid.clientWidth / grid.scrollWidth) * 100, 10);
      var maxLeftPct = 100 - thumbWidthPct;
      var scrollPct = grid.scrollLeft / scrollable;
      thumb.style.width = thumbWidthPct + '%';
      thumb.style.left = (scrollPct * maxLeftPct) + '%';
    }

    grid.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
    setTimeout(update, 300);
    setTimeout(update, 1000);
  }

  function initAll() {
    document.querySelectorAll('[id^="ProductRecommendedForYou-"]').forEach(function (el) {
      init(el);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
})();